import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import { getAdjustedOnboardingStep } from "../../../../../Utils/onboarding/getAdjustedOnboardingStep.js"
import { getJourneyState, JOURNEY_FLOWS } from "../../../../../Utils/onboarding/getJourneyState.js"
import { getOnboardingAccess } from "../../../../../Utils/onboarding/getOnboardingAccess.js"
import { createAccountStepPath } from "../../../../../Utils/utils.js"

const useBusinessStepsBlock = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const new_onboarding_finished = useSelector(
    (state) => state.auth.userInfo.new_onboarding_finished
  )

  const userInfo = useSelector((state) => state.auth.userInfo)
  const userState = useSelector((state) => state.user)
  const businessAccountsFetching = useSelector((state) => state.user.businessAccountsFetching)
  const journey = getJourneyState({
    userInfo,
    userState,
    pathname
  })
  const { isStepCompleted, isStepCurrent, completedBusinessStep } = getOnboardingAccess({
    nextCreateAccountStep: getAdjustedOnboardingStep(journey.currentStep, new_onboarding_finished),
    isInvite: journey.flow === JOURNEY_FLOWS.INVITED_CREATE_BUSINESS
  })

  const preparedSteps = journey.steps.map((s) => ({
    ...s,
    isCompleted: isStepCompleted(getAdjustedOnboardingStep(s.step, new_onboarding_finished)),
    isContinue: isStepCurrent(getAdjustedOnboardingStep(s.step, new_onboarding_finished))
  }))

  const handleContinue = (step) => {
    navigate(createAccountStepPath[step])
  }

  return {
    preparedSteps,
    handleContinue,
    completedBusinessStep,
    businessAccountsFetching
  }
}

export default useBusinessStepsBlock
